import React from "react";
import {
  Dialog,
  Flex,
  Checkbox,
  CloseIcon,
  Text,
  Divider,
  Loader,
} from "@fluentui/react-northstar";
import "./TrustNetworkConfigDialog.scss";
import { useTranslation } from "react-i18next";

const TrustNetworkConfigDialog = ({
  open,
  onCancel,
  onConfirm,
  shareCollection,
  setShareCollection,
  shareSpinWheel,
  setShareSpinWheel,
  note,
  isUpdating = false,
}) => {
  const { t } = useTranslation();
  const translation = t("trustedNetwork").trustedNetworkConfigDialog;

  return (
    <Dialog
      open={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
      header={translation.header}
      confirmButton={{
        content: translation.save,
        primary: true,
        loading: isUpdating,
        disabled: isUpdating,
      }}
      cancelButton={{
        content: translation.cancel,
        disabled: isUpdating,
      }}
      className="trust-network-config-dialog"
      content={
        <>
          <Text
            content={translation.disclaimerText}
            style={{
              color: "#b26a00",
              background: "#fffbe6",
              padding: "8px 12px",
              borderRadius: "4px",
              marginBottom: "12px",
              display: "block",
              fontSize: "13px",
            }}
          />
          <Text content={translation.note || note} color="grey" size="small" />
          <Divider styles={{ margin: "10px 0" }} size={2} />
          <Flex column gap="gap.medium">
            <Checkbox
              label={translation.shareCollection}
              checked={shareCollection}
              onChange={setShareCollection}
              disabled={isUpdating}
            />
            <Checkbox
              label={translation.shareSpinWheel}
              checked={shareSpinWheel}
              onChange={setShareSpinWheel}
              disabled={isUpdating}
            />
          </Flex>
        </>
      }
      headerAction={
        isUpdating
          ? null
          : {
              icon: <CloseIcon />,
              title: translation.close,
              onClick: onCancel,
            }
      }
    />
  );
};

export default TrustNetworkConfigDialog;
